/**
 * Root mount for seasonal decoration.
 *
 * Looks up the currently selected color theme's decoration (backdrop + ambient
 * effects) and mounts it. The palette itself is applied by ThemeContext via the
 * `data-theme` attribute; this layer only adds the matching scenery. Renders
 * nothing for non-seasonal themes.
 */
import React from 'react';

import { useTheme } from '@shared/hooks/useTheme';

import { BACKGROUND_COMPONENTS } from './backgrounds/registry';
import { SEASONAL_DECORATIONS } from './decorations';
import { EFFECT_COMPONENTS } from './effects/registry';

/** Mount once near the app root; decorates the selected seasonal theme. */
export const SeasonalLayer: React.FC = () => {
  const { colorTheme } = useTheme();
  const decoration = SEASONAL_DECORATIONS[colorTheme];
  if (!decoration) return null;

  const Background = decoration.background ? BACKGROUND_COMPONENTS[decoration.background] : null;
  const effects = decoration.effects ?? [];

  return (
    <>
      {Background ? <Background /> : null}
      {effects.map(id => {
        const Effect = EFFECT_COMPONENTS[id];
        return Effect ? <Effect key={id} /> : null;
      })}
    </>
  );
};
